import { Link } from "react-router-dom";
import { ArrowRight, Droplet, ShieldCheck, Sparkles } from "lucide-react";
import { HelichrysumIcon } from "@/components/brand/HelichrysumIcon";
import { MaskedLines } from "@/components/motion/MaskedLines";
import { Reveal } from "@/components/motion/Reveal";

const BENEFITS = [
  { icon: ShieldCheck, label: "Pelle più protetta" },
  { icon: Droplet, label: "Idratazione e nutrimento" },
  { icon: Sparkles, label: "Igiene sicura e delicata" },
  { icon: HelichrysumIcon, label: "Con postbiotici dell'elicriso" },
];

export const ClosingCta = () => (
  <section className="bg-ivory py-24 lg:py-36" data-testid="closing-section">
    <div className="container-pf grid items-center gap-14 lg:grid-cols-12">
      <Reveal className="lg:col-span-7">
        <div className="relative overflow-hidden rounded-[2.5rem] ring-1 ring-copper/25">
          <img src="/images/scene-pharmacy.jpg" alt="Espositore Perfero Benessere Silver Age in farmacia" loading="lazy" className="aspect-[4/3] w-full object-cover" />
        </div>
      </Reveal>
      <div className="lg:col-span-5">
        <p className="eyebrow">Perfero per la vostra quotidianità</p>
        <h2 className="mt-5 font-display text-4xl font-medium leading-[1.04] text-navy sm:text-5xl">
          <MaskedLines lines={["La cura completa", "per la tua dolce", <em className="italic text-copper">quotidianità.</em>]} />
        </h2>
        <ul className="mt-10 space-y-5">
          {BENEFITS.map(({ icon: Icon, label }) => (
            <li key={label} className="flex items-center gap-4 text-lg text-navy">
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full border border-copper/40 text-copper">
                <Icon className="h-5 w-5" strokeWidth={1.5} />
              </span>
              {label}
            </li>
          ))}
        </ul>
        <Link to="/collezione" data-testid="closing-cta" className="btn-primary group mt-12">
          Acquista la linea <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
        </Link>
      </div>
    </div>
  </section>
);
